import { Typography } from '@mui/material';
import moment from 'moment';
import { toast } from 'react-toastify';
import { ICONS } from 'src/assets/library';

export const PHONE_NUMBER_REGEX = /^\+243\d{9}$/;

export const constants = {
  authToken: 'token',
  pending: 'PENDING',
  joined: 'JOINED',
  languageKey: 'language',
  defaultLanguage: 'FRENCH',
  notificationToken: 'notificationToken',
};
export const OTP_VERIFICATION_MODE = {
  NEW_USER: 'NEW_USER',
  JOIN_USER: 'JOIN_USER',
  ACCOUNT_RECOVERY: 'ACCOUNT_RECOVERY',
  LOGIN: 'LOGIN',
};

export const roleArray = [
  { value: 'default', label: 'Choose role', disabled: true },
  { value: 'CEO', label: 'CEO' },
  { value: 'ADMINISTRATOR', label: 'ADMINISTRATOR' },
  { value: 'OPERATOR', label: 'OPERATOR' },
];
export const genderArray = [
  { value: 'default', label: 'Select Gender', disabled: true },
  { value: 'MALE', label: 'Male' },
  { value: 'FEMALE', label: 'Female' },
  { value: 'OTHER', label: 'Other' },
];
export const userStatusArray = [
  { value: '', label: 'Choose status' },
  { value: 'PENDING', label: 'PENDING' },
  { value: 'JOINED', label: 'JOINED' },
  { value: 'DELETED', label: 'DELETED' },
];
export const orderStatusArray = [
  { value: '', label: 'Choose Status' },
  { value: 'PENDING_REVIEW', label: 'PENDING_REVIEW' },
  { value: 'NEGOTIATION_SUCCESSFUL', label: 'NEGOTIATION_SUCCESSFUL' },
  { value: 'NEGOTIATION_FAILURE', label: 'NEGOTIATION_FAILURE' },
  { value: 'PAYMENT_RECEIVED', label: 'PAYMENT_RECEIVED' },
  { value: 'COMPLETED', label: 'COMPLETED' },
];
export const orderStatusArrayAll = [
  { value: 'default', label: 'All' },
  { value: 'PENDING_REVIEW', label: 'PENDING_REVIEW' },
  { value: 'NEGOTIATION_SUCCESSFUL', label: 'NEGOTIATION_SUCCESSFUL' },
  { value: 'NEGOTIATION_FAILURE', label: 'NEGOTIATION_FAILURE' },
  { value: 'PAYMENT_RECEIVED', label: 'PAYMENT_RECEIVED' },
  { value: 'COMPLETED', label: 'COMPLETED' },
];
export const subOrderStatusArray = [
  { value: 'default', label: 'All' },
  { value: 'IN_QUEUE', label: 'IN_QUEUE' },
  { value: 'IN_PROGRESS', label: 'IN_PROGRESS' },
  { value: 'PREPARING', label: 'PREPARING' },
  { value: 'READY_FOR_DISPATCHED', label: 'READY_FOR_DISPATCHED' },
  { value: 'DISPATCHED', label: 'DISPATCHED' },
  { value: 'DELIVERED', label: 'DELIVERED' },
];
export const subOrderSortArray = [
  { value: 'default', label: 'Default' },
  { value: true, label: 'Ascending' },
  { value: false, label: 'Descending' },
];
export const months = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];
export const statusOptions = {
  PENDING_REVIEW: [
    { value: '', label: 'Choose Status', disabled: true },
    { value: 'PENDING_REVIEW', label: 'PENDING_REVIEW' },
    { value: 'NEGOTIATION_SUCCESSFUL', label: 'NEGOTIATION_SUCCESSFUL' },
    { value: 'NEGOTIATION_FAILURE', label: 'NEGOTIATION_FAILURE' },
    { value: 'PAYMENT_RECEIVED', label: 'PAYMENT_RECEIVED', disabled: true },
    { value: 'COMPLETED', label: 'COMPLETED', disabled: true },
  ],
  NEGOTIATION_FAILURE: [
    { value: '', label: 'Choose Status', disabled: true },
    { value: 'PENDING_REVIEW', label: 'PENDING_REVIEW', disabled: true },
    { value: 'NEGOTIATION_SUCCESSFUL', label: 'NEGOTIATION_SUCCESSFUL', disabled: true },
    { value: 'NEGOTIATION_FAILURE', label: 'NEGOTIATION_FAILURE' },
    { value: 'PAYMENT_RECEIVED', label: 'PAYMENT_RECEIVED', disabled: true },
    { value: 'COMPLETED', label: 'COMPLETED', disabled: true },
  ],
  NEGOTIATION_SUCCESSFUL: [
    { value: '', label: 'Choose Status', disabled: true },
    { value: 'PENDING_REVIEW', label: 'PENDING_REVIEW', disabled: true },
    { value: 'NEGOTIATION_SUCCESSFUL', label: 'NEGOTIATION_SUCCESSFUL' },
    { value: 'PAYMENT_RECEIVED', label: 'PAYMENT_RECEIVED' },
    { value: 'COMPLETED', label: 'COMPLETED', disabled: true },
  ],
  PAYMENT_RECEIVED: [
    { value: '', label: 'Choose Status', disabled: true },
    { value: 'PENDING_REVIEW', label: 'PENDING_REVIEW', disabled: true },
    { value: 'NEGOTIATION_SUCCESSFUL', label: 'NEGOTIATION_SUCCESSFUL', disabled: true },
    { value: 'PAYMENT_RECEIVED', label: 'PAYMENT_RECEIVED' },
    { value: 'COMPLETED', label: 'COMPLETED', disabled: true },
  ],
  COMPLETED: [
    { value: '', label: 'Choose Status', disabled: true },
    { value: 'PENDING_REVIEW', label: 'PENDING_REVIEW', disabled: true },
    { value: 'NEGOTIATION_SUCCESSFUL', label: 'NEGOTIATION_SUCCESSFUL', disabled: true },
    { value: 'PAYMENT_RECEIVED', label: 'PAYMENT_RECEIVED', disabled: true },
    { value: 'COMPLETED', label: 'COMPLETED' },
  ],
};
export const paymentMethodArray = [
  { value: 'default', label: 'Choose Payment Method', disabled: true },
  { value: 'CASH', label: 'CASH' },
  // { value: 'UNIPESA', label: 'UNIPESA' },
  { value: 'BANK_ACCOUNT', label: 'BANK_ACCOUNT' },
];
export const deliveryTimeArray = [
  { value: 'default', label: 'Choose Delivery Time', disabled: true },
  { value: 'MORNING', label: 'MORNING' },
  { value: 'AFTERNOON', label: 'AFTERNOON' },
  { value: 'NIGHT', label: 'NIGHT' },
];
export const showSuccessTost = (msg) => {
  toast.success(msg, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const showErrorTost = (msg) => {
  toast.error(msg, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const showDate2 = (date) => moment(date).format('DD/MM/YYYY');
// export const showTime = (date) => moment(date).format('LT');
export const showDateFull = (date) => moment(date).format('D MMMM YYYY');
// export const showDateFromString = (date) => moment(date).format('YYYY-MM-DD');
export const showDate = (date) => moment(date).format('MMMM D, YYYY');
// export const showTime = (date) => moment(date).format('LT');
// export const showDateInvoice = (date) => moment(date).format('MM/DD/YYYY');
export const showDateFromString = (date) => moment(date).format('YYYY-MM-DD');

export const removeEmptyKeys = (obj) =>
  Object.entries(obj).reduce(
    (acc, [key, value]) =>
      value !== null &&
      value !== undefined &&
      value !== '' &&
      !(Array.isArray(value) && value.length === 0) &&
      !(typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
        ? { ...acc, [key]: value }
        : acc,
    {}
  );

export function formatDate(dateStr) {
  const [year, month, day] = dateStr.split('-');
  return `${day}/${month}/${year}`;
}

export function formatWeekResponse(week) {
  return week.replace(/\d{4}-\d{2}-\d{2}/g, formatDate);
}
export function formatMonthReponse(month) {
  return moment(month, 'MMMM YYYY').format('MM/YYYY');
}

export const formatNumber = (num) => {
  if (num >= 1e9) {
    return (num / 1e9).toFixed(3).replace(/\.0$/, '') + 'B';
  }
  if (num >= 1e6) {
    return (num / 1e6).toFixed(3).replace(/\.0$/, '') + 'M';
  }
  if (num >= 1e3) {
    return (num / 1e3).toFixed(3).replace(/\.0$/, '') + 'K';
  }
  return num.toString();
};

export const formatNumberSpacing = (num) => {
  return Number(num)
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export const revenueSectionIcons = [ICONS.today, ICONS.week, ICONS.month, ICONS.quarter, ICONS.year];
export const orderSectionIcons = {
  PENDING_REVIEW: { icon: ICONS.pendingReview, step: 1 },
  NEGOTIATION_SUCCESSFUL: { icon: ICONS.negotiationSuccess, step: 2 },
  NEGOTIATION_FAILURE: { icon: ICONS.negotiationFail, step: 2 },
  PAYMENT_RECEIVED: { icon: ICONS.paymentRecieved, step: 3 },
  IN_PROGRESS: { icon: ICONS.inProgress, step: 4 },
  PREPARING: { icon: ICONS.preparing, step: 5 },
  READY_FOR_DISPATCHED: { icon: ICONS.readyDispatch, step: 6 },
  DISPATCHED: { icon: ICONS.dispatched, step: 7 },
  DELIVERED: { icon: ICONS.delivered, step: 8 },
  COMPLETED: { icon: ICONS.completed, step: 9 },
};
export const operatorDashboardColumns = ['dosage', 'volumeOfConcrete', 'deliveryDate', 'createdAt', 'timeOfDelivery'];
export const customerDashboardColumns = ['volumeOfConcrete', 'perCubicMeterConcretePrice', 'createdAt', 'deliveryDate'];

export const orderToolTipContentEnglish = {
  PENDING_REVIEW: (
    <>
      <Typography variant="body2">
        This section contains all order requests where the admin still needs to contact the client. The negotiation call
        is essential because concrete pricing is not fixed and varies per client.
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>The admin must call the client to discuss pricing and terms.
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>If the negotiation is{' '}
        <span style={{ fontWeight: 900 }}>successful</span>, the order is moved by the admin to "Negotiation
        Successful."
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>If the negotiation <span style={{ fontWeight: 900 }}>fails</span>,
        the order is moved by the admin to "Negotiation Unsuccessful."
      </Typography>
    </>
  ),
  NEGOTIATION_FAILURE: (
    <Typography variant="body2">
      This section lists all orders where the client did not agree on the pricing or terms. These orders are considered
      lost and require no further action unless a follow-up is later requested.
    </Typography>
  ),
  NEGOTIATION_SUCCESSFUL: (
    <>
      <Typography variant="body2">
        These are all orders where the client has <span style={{ fontWeight: 900 }}>agreed on the price and terms</span>{' '}
        during the negotiation call.
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>The next step is for the client to{' '}
        <span style={{ fontWeight: 900 }}>make the payment.</span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>The admin should{' '}
        <span style={{ fontWeight: 900 }}>wait for the payment</span> before updating the order to "Payment Received."
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>Once the payment is confirmed, the admin{' '}
        <span style={{ fontWeight: 900 }}>must manually update the order</span> status to "Payment Received."
      </Typography>
    </>
  ),
  PAYMENT_RECEIVED: (
    <>
      <Typography variant="body2">
        This section contains all <span style={{ fontWeight: 900 }}>orders for which payment has been confirmed.</span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>
        <span style={{ fontWeight: 900 }}>
          The administrator must not change this status until payment has been received in full.
        </span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>Once payment has been{' '}
        <span style={{ fontWeight: 900 }}>confirmed and updated</span> by the administrator, the{' '}
        <span style={{ fontWeight: 900 }}>order changes to "Payment Received."</span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>
        <span style={{ fontWeight: 900 }}>
          All items in the order are then automatically moved to the "In Progress" section
        </span>{' '}
        , where they will wait to be picked up by the operator for preparation.
      </Typography>
    </>
  ),
  IN_PROGRESS: (
    <>
      <Typography variant="body2">
        This section tracks individual order items that are not yet being prepared by the operator but for which the
        payment of the order has already been received.
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>The
        <span style={{ fontWeight: 900 }}>order is still visible in the section "Payment received."</span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>The{' '}
        <span style={{ fontWeight: 900 }}>order remains in "Payment received"</span> until{' '}
        <span style={{ fontWeight: 900 }}>all order items are fully delivered.</span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>Once <span style={{ fontWeight: 900 }}>all order</span> items are
        marked as "Delivered," the <span style={{ fontWeight: 900 }}>order is updated to "Order Complete."</span>
      </Typography>
    </>
  ),
  PREPARING: (
    <>
      <Typography variant="body2">
        The operator has started processing the order item and has{' '}
        <span style={{ fontWeight: 900 }}>entered all necessary raw material quantities</span> in the platform.
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>This stage includes{' '}
        <span style={{ fontWeight: 900 }}>mixing the concrete and verifying the order item details.</span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>Once the preparation is finished, the operator must manually update
        the status to "Ready for Dispatch."
      </Typography>
    </>
  ),
  READY_FOR_DISPATCHED: (
    <>
      <Typography variant="body2">
        These are all order items where the operator has finished the preparation and the order item is{' '}
        <span style={{ fontWeight: 900 }}>ready to be loaded for delivery.</span> This status is set by the operator
        when he is done preparing the order item.
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>The dispatch team should now be informed to arrange the
        transportation.
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>Once the order item leaves the facility, the admin should update it
        to "Dispatched."
      </Typography>
    </>
  ),
  DISPATCHED: (
    <>
      <Typography variant="body2">
        These order items have <span style={{ fontWeight: 900 }}>left the facility</span> and are currently{' '}
        <span style={{ fontWeight: 900 }}>on the way to the delivery location.</span>
      </Typography>
      <Typography variant="body2">
        {' '}
        <span style={{ fontSize: '20px' }}> • </span>The admin updates this status{' '}
        <span style={{ fontWeight: 900 }}>on the day of delivery.</span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>Once the order item arrives at the client’s location, the admin
        must update the status to "Delivered."
      </Typography>
    </>
  ),
  DELIVERED: (
    <Typography variant="body2">
      These order items have been successfully <span style={{ fontWeight: 900 }}>delivered to the client.</span>{' '}
      However, if an order contains multiple order items, the order itself remains in{' '}
      <span style={{ fontWeight: 900 }}>'Payment Received'</span> until all order items are delivered. Once all order
      items are delivered, the system automatically updates the order to{' '}
      <span style={{ fontWeight: 900 }}>'Order Complete'.</span>
    </Typography>
  ),
  COMPLETED: (
    <Typography variant="body2">
      This section contains orders where{' '}
      <span style={{ fontWeight: 900 }}>all order items have been successfully delivered</span> Once the last order item
      is delivered, the system automatically updates the order to
      <span style={{ fontWeight: 900 }}>'Order Complete'.</span>The admin does not need to take further action.
    </Typography>
  ),
};

export const orderToolTipContentFrench = {
  PENDING_REVIEW: (
    <>
      <Typography variant="body2">
        Cette section contient toutes les demandes de commande pour lesquelles l'administrateur doit encore contacter le
        client. L'appel de négociation est essentiel car le prix des produits béton n'est pas fixe et varie selon les
        clients.
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>L'administrateur doit appeler le client pour discuter des prix et
        des conditions.
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>Si la négociation <span style={{ fontWeight: 900 }}>aboutit</span>,
        l'administrateur met à jour la commande en la passant à « Négociation réussie ».
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>Si la négociation <span style={{ fontWeight: 900 }}>échoue</span>,
        la commande est déplacée par l'administrateur vers « Négociation non réussie ».
      </Typography>
    </>
  ),
  NEGOTIATION_FAILURE: (
    <Typography variant="body2">
      Cette section répertorie toutes les commandes pour lesquelles le client n'a pas accepté le prix ou les conditions.
      Ces commandes sont considérées comme perdues et ne nécessitent aucune autre action, sauf si un suivi est demandé
      ultérieurement.
    </Typography>
  ),
  NEGOTIATION_SUCCESSFUL: (
    <>
      <Typography variant="body2">
        Il s'agit de toutes les commandes pour lesquelles le client a{' '}
        <span style={{ fontWeight: 900 }}>accepté le prix et les conditions</span> lors de l'appel de négociation.
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>L'étape suivante consiste pour le client à{' '}
        <span style={{ fontWeight: 900 }}>effectuer le paiement.</span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>L'administrateur doit{' '}
        <span style={{ fontWeight: 900 }}>attendre le paiement</span> avant de mettre à jour la commande en indiquant «
        Paiement reçu ».
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>Une fois le paiement confirmé, l'administrateur{' '}
        <span style={{ fontWeight: 900 }}>doit manuellement mettre à jour le statut de la commande</span> avec la
        mention « Paiement reçu ».
      </Typography>
    </>
  ),
  PAYMENT_RECEIVED: (
    <>
      <Typography variant="body2">
        Cette section contient toutes les{' '}
        <span style={{ fontWeight: 900 }}>commandes dont le paiement a été confirmé.</span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>
        <span style={{ fontWeight: 900 }}>
          L'administrateur ne doit pas modifier ce statut tant que le paiement n'a pas été intégralement reçu.
        </span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>Une fois le paiement{' '}
        <span style={{ fontWeight: 900 }}>confirmé et mis à jour</span> par l'administrateur, la{' '}
        <span style={{ fontWeight: 900 }}>commande passe en "Paiement Reçu".</span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>
        Tous <span style={{ fontWeight: 900 }}>les articles de la commande</span> sont alors visibles dans la section{' '}
        <span style={{ fontWeight: 900 }}>« En cours »,</span> où ils attendront d’être pris en charge par l’opérateur
        pour la préparation.
      </Typography>
    </>
  ),
  IN_PROGRESS: (
    <>
      <Typography variant="body2">
        <span style={{ fontWeight: 900 }}>
          Cette section répertorie les articles d’une commande en attente de préparation par l'opérateur, mais pour
          lesquels le paiement de la commande a déjà été reçu.
        </span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>La
        <span style={{ fontWeight: 900 }}> commande est toujours visible dans la section « Paiement reçu ».</span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>La{' '}
        <span style={{ fontWeight: 900 }}>commande reste dans la section « Paiement reçu »</span> jusqu'à ce que{' '}
        <span style={{ fontWeight: 900 }}>tous les articles de la commande soient entièrement livrés.</span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>Une fois que{' '}
        <span style={{ fontWeight: 900 }}>tous les articles de la commande</span> sont marqués comme « livrés », la{' '}
        <span style={{ fontWeight: 900 }}>commande est mise à jour et devient « Commande terminée ».</span>
      </Typography>
    </>
  ),
  PREPARING: (
    <>
      <Typography variant="body2">
        L'opérateur a commencé à traiter l’article et a{' '}
        <span style={{ fontWeight: 900 }}>saisi toutes les quantités de matières premières nécessaires</span> dans la
        plate-forme.
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>Cette étape comprend le{' '}
        <span style={{ fontWeight: 900 }}>mélange du béton et la vérification des détails de la commande.</span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>Une fois la préparation terminée, l'opérateur doit manuellement
        mettre à jour le statut « Prêt pour l'expédition ».
      </Typography>
    </>
  ),
  READY_FOR_DISPATCHED: (
    <>
      <Typography variant="body2">
        Il s'agit de tous les articles pour lesquels l'opérateur a terminé la préparation et qui sont{' '}
        <span style={{ fontWeight: 900 }}>prêts à être chargés pour la livraison.</span> Ce statut est défini par
        l'opérateur lorsqu'il a terminé la préparation de l’article.
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>L'équipe d'expédition doit alors être informée pour organiser le
        transport.
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>Une fois que l'article a quitté l'établissement, l'administrateur
        doit mettre à jour le statut « Expédition ».
      </Typography>
    </>
  ),
  DISPATCHED: (
    <>
      <Typography variant="body2">
        Ces articles ont <span style={{ fontWeight: 900 }}>quitté l'établissement</span> et sont{' '}
        <span style={{ fontWeight: 900 }}>en cours d'acheminement vers le lieu de livraison.</span>
      </Typography>
      <Typography variant="body2">
        {' '}
        <span style={{ fontSize: '20px' }}> • </span>L'administrateur met à jour ce statut{' '}
        <span style={{ fontWeight: 900 }}>le jour de la livraison.</span>
      </Typography>
      <Typography variant="body2">
        <span style={{ fontSize: '20px' }}> • </span>Une fois que l'article arrive chez le client, l'administrateur doit
        mettre à jour le statut « Livré ».
      </Typography>
    </>
  ),
  DELIVERED: (
    <Typography variant="body2">
      Ces articles ont été <span style={{ fontWeight: 900 }}>livrés</span> avec succès{' '}
      <span style={{ fontWeight: 900 }}>au client.</span> Toutefois, si une commande contient plusieurs articles, elle
      reste dans la <span style={{ fontWeight: 900 }}>catégorie « Paiement reçu »</span> jusqu'à ce que tous les
      articles de cette commande aient été livrés. Une fois que tous les articles de la commande ont été livrés, le
      système met automatiquement à jour la commande en la faisant passer à{' '}
      <span style={{ fontWeight: 900 }}>« Commande terminée ».</span>
    </Typography>
  ),
  COMPLETED: (
    <Typography variant="body2">
      Cette section contient les commandes dont tous les articles ont été livrés avec succès. Lorsque le dernier article
      de la commande a été livré, le système met automatiquement à jour la commande avec la mention « Commande terminée
      ». L'administrateur n'a pas besoin de prendre d'autres mesures.
    </Typography>
  ),
};
